export { ThumbDown as default } from './ThumbDown';
